var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "85.000000pt",
    height: "94.000000pt",
    viewBox: "0 0 85.000000 94.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,94.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160 895 l0 -35 -55 0 c-42 0 -60 -5 -75 -20 -19 -19 -20 -33 -20 -405 0 -372 1 -386 20 -405 19 -19 33 -20 395 -20 362 0 376 1 395 20 19 19 20 33 20 405 0 372 -1 386 -20 405 -15 15 -33 20 -75 20 l-55 0 0 35 c0 31 -3 35 -25 35 -22 0 -25 -4 -25 -35 l0 -35 -215 0 -215 0 0 35 c0 31 -3 35 -25 35 -22 0 -25 -4 -25 -35z m630 -170 l0 -85 -365 0 -365 0 0 85 0 85 365 0 365 0 0 -85z m0 -400 l0 -265 -365 0 -365 0 0 265 0 265 365 0 365 0 0 -265z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 446 c-21 -26 -9 -51 24 -51 27 0 30 3 30 30 0 23 -5 31 -21 33 -11 2 -26 -4 -33 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402 451 c-8 -4 -12 -19 -10 -32 2 -19 9 -24 33 -24 27 0 30 3 30 30 0 22 -5 31 -20 33 -11 1 -26 -2 -33 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584 446 c-3 -8 -4 -23 -2 -33 5 -25 61 -25 66 0 7 37 -51 67 -64 33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204 256 c-12 -31 0 -51 31 -51 27 0 30 3 30 30 0 25 -4 30 -28 33 -17 2 -29 -2 -33 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394 256 c-12 -31 0 -51 31 -51 27 0 30 3 30 30 0 25 -4 30 -28 33 -17 2 -29 -2 -33 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584 256 c-12 -31 0 -51 31 -51 27 0 30 3 30 30 0 25 -4 30 -28 33 -17 2 -29 -2 -33 -12z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.89f35d2bc588b8a77f29d6818e914b20.svg";
export { ForwardRef as ReactComponent };